module.exports = __webpack_public_path__ + "img/trollshaws-3018-10-18.2073ac07.jpg";